import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import ShowcasePageWidget from "./ShowcasePageWidget";

export default function EditMyMemberPage() {
  const navigate = useNavigate();

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-gray-900">Edit Your Member Showcase Page</h1>
        <p className="text-gray-600 text-sm mt-1">
          Add HTML to highlight your services. Use "Make Page Active" when you are ready to show it
          in the navigation menu.
        </p>
      </div>
      <ShowcasePageWidget />
      <div className="mt-3 flex justify-start">
        <Button color="light" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  );
}
